import { store } from '../../index';
var ClientHelper = /** @class */ (function () {
    function ClientHelper() {
    }
    ClientHelper.abortPreviousRequest = function (abortController) {
        if (abortController) {
            abortController.abort();
        }
    };
    ClientHelper.dispatchNewRequestAction = function (storageKeyParam, actionType, abortControllerParam) {
        var requestAction = {
            storageKey: storageKeyParam,
            type: actionType,
            abortController: abortControllerParam,
        };
        store.dispatch(requestAction);
    };
    ClientHelper.cleanUpRoomAndBoardOptions = function (request) {
        if (request && request.query) {
            if (request.query.OPTIONS && Array.isArray(request.query.OPTIONS)) {
                request.query.OPTIONS = request.query.OPTIONS.filter(function (option) { return !((option > 1301 && option < 1400) || (option > 1401 && option < 1500) || (option >= 12000 && option <= 12200)); });
            }
            if (request.query.HOTEL_ROOM_VIEW_CODES && Array.isArray(request.query.HOTEL_ROOM_VIEW_CODES)) {
                request.query.HOTEL_ROOM_VIEW_CODES = request.query.HOTEL_ROOM_VIEW_CODES.filter(function (viewCodes) { return 'GT13-SEVI' !== viewCodes; });
            }
        }
    };
    return ClientHelper;
}());
export default ClientHelper;
